"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../bind");
var lodash_1 = require("lodash");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var tokenized_cvv_field_1 = require("./tokenized_cvv_field");
exports.connectReverifyCardMutation = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["mutation reverifyCreditCardMutation($input: Input_core_apimessages_ReverifyCreditCardRequest) {\n    reverifyCreditCard(input: $input) {\n      creditCard {\n        id\n        last4\n        cardType\n        expirationYear\n        expirationMonth\n        cardholderName\n        needsReverification\n        primaryForCheckout\n      }\n    }\n  }"], ["mutation reverifyCreditCardMutation($input: Input_core_apimessages_ReverifyCreditCardRequest) {\n    reverifyCreditCard(input: $input) {\n      creditCard {\n        id\n        last4\n        cardType\n        expirationYear\n        expirationMonth\n        cardholderName\n        needsReverification\n        primaryForCheckout\n      }\n    }\n  }"]))), {
    name: 'reverifyCreditCard',
    options: {
        ssr: false,
    },
});
var ReverifyCardContainer = /** @class */ (function (_super) {
    tslib_1.__extends(ReverifyCardContainer, _super);
    function ReverifyCardContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFormSaving: false,
            error: '',
            tokenizedFields: {
                encryptedSecurityCode: '',
            },
        };
        return _this;
    }
    ReverifyCardContainer.prototype.onTokenizedFieldUpdate = function (newTokenizedFields) {
        var tokenizedFields = tslib_1.__assign(tslib_1.__assign({}, this.state.tokenizedFields), newTokenizedFields);
        this.setState({ tokenizedFields: tokenizedFields });
    };
    ReverifyCardContainer.prototype.disableSubmit = function () {
        return (this.state.isFormSaving ||
            !this.state.tokenizedFields.encryptedSecurityCode);
    };
    ReverifyCardContainer.prototype.handleSubmit = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var errors_1, message;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        this.setState({ isFormSaving: true, error: '' });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.doReverifyCard()];
                    case 2:
                        _a.sent();
                        this.setState({ isFormSaving: false });
                        return [3 /*break*/, 4];
                    case 3:
                        errors_1 = _a.sent();
                        message = lodash_1.first(lodash_1.get(errors_1, 'graphQLErrors', [{ message: '' }])).message;
                        this.setState({ error: message, isFormSaving: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReverifyCardContainer.prototype.doReverifyCard = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tokenizedFieldsJson, input, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenizedFieldsJson = JSON.stringify(this.state.tokenizedFields);
                        input = {
                            creditCardId: this.props.creditCardId,
                            tokenizedFields: tokenizedFieldsJson,
                        };
                        return [4 /*yield*/, this.props.reverifyCreditCard({ variables: { input: input } })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, lodash_1.get(result, 'data.creditCard')];
                }
            });
        });
    };
    ReverifyCardContainer.prototype.errorReverifying = function () {
        return this.state.error !== '';
    };
    ReverifyCardContainer.prototype.render = function () {
        return (React.createElement(tokenized_cvv_field_1.default, { creditCardId: this.props.creditCardId, onTokenizedFieldUpdate: this.onTokenizedFieldUpdate, errorReverifying: this.errorReverifying(), disableSubmit: this.disableSubmit(), onSubmit: this.handleSubmit }));
    };
    tslib_1.__decorate([
        bind_1.default
    ], ReverifyCardContainer.prototype, "onTokenizedFieldUpdate", null);
    tslib_1.__decorate([
        bind_1.default
    ], ReverifyCardContainer.prototype, "handleSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], ReverifyCardContainer.prototype, "doReverifyCard", null);
    return ReverifyCardContainer;
}(React.Component));
exports.ReverifyCardContainer = ReverifyCardContainer;
var connectReverifyCardContainer = react_apollo_1.compose(exports.connectReverifyCardMutation)(ReverifyCardContainer);
exports.default = connectReverifyCardContainer;
var templateObject_1;
//# sourceMappingURL=reverify_card_container.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/reverify_card_container.js
// module id = 2KAK
// module chunks = 20 21 22